import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';
// Debe ir después de los estilos de BUI para sobrescribir sus tokens.
import './bui.css';

ReactDOM.createRoot(document.getElementById('root')!).render(App.createRoot());
